export const getCSRFToken = () => document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
